export default "__VITE_ASSET__C0sgB0qy__"